import { logEvent } from './logGaEvent'

const logFlexDatesDisplay = ({ flexDates, minimumListingPrice, travelDateHasExd }) => {
  const numFlexDates = flexDates.length
  const prices = flexDates.map((date) => date.minimumFare?.amtPerPax).filter(Boolean)
  const priceMap = {
    cheapest: Math.min(...prices),
    mostExpensive: Math.max(...prices),
  }

  const travelDateFareType = travelDateHasExd ? 'exd' : 'rtl'
  const isTravelDateCheapest = minimumListingPrice <= priceMap.cheapest
  const isTravelDateMostExpensive = minimumListingPrice >= priceMap.mostExpensive
  const isTravelDateCheaper =
    priceMap.cheapest < minimumListingPrice && minimumListingPrice < priceMap.mostExpensive

  let itemNameTag = ''
  /* istanbul ignore else */
  if (isTravelDateCheapest) {
    itemNameTag = 'cheapest'
  } else if (isTravelDateMostExpensive) {
    itemNameTag = 'most-expensive'
  } else if (isTravelDateCheaper) {
    itemNameTag = 'cheaper'
  }

  logEvent('display', {
    type: 'flex_dates',
    item_name: `${numFlexDates}_${travelDateFareType}_${itemNameTag}`,
    page_name: 'listings',
    product_name: 'air',
  })
}

const logFlexDatesClick = ({ flexDates, minimumListingPrice, selectedIndex, travelDate, sliceInfo }) => {
  const indexOfTravelDate = flexDates.findIndex((date) => date.dates?.[0] === travelDate)
  const dayDifference = selectedIndex - indexOfTravelDate
  const linkName = `${Math.abs(dayDifference)}${dayDifference > 0 ? '+' : '-'}`

  const selectedDate = flexDates[selectedIndex]
  const selectedDatePrice = selectedDate?.minimumFare?.amtPerPax
  const selectedDateFareType = selectedDate?.minimumFare?.isPrivateFare ? 'exd' : 'rtl'

  const prices = flexDates.map((date) => date.minimumFare?.amtPerPax).filter(Boolean)
  const priceMap = {
    cheapest: Math.min(...prices),
    mostExpensive: Math.max(...prices),
  }

  let linkText = ''
  /* istanbul ignore else */
  if (selectedDatePrice <= priceMap.cheapest) {
    linkText = 'cheapest'
  } else if (selectedDatePrice >= priceMap.mostExpensive) {
    linkText = 'most_expensive'
  } else if (selectedDatePrice === minimumListingPrice) {
    linkText = 'same'
  } else if (selectedDatePrice < minimumListingPrice && selectedDatePrice > priceMap.cheapest) {
    linkText = 'cheaper'
  } else if (selectedDatePrice > minimumListingPrice && selectedDatePrice < priceMap.mostExpensive) {
    linkText = 'more_expensive'
  }

  if (window.localStorage) {
    const selectedFlexDate = flexDates[selectedIndex].dates[0]
    const selectedFlexDateInfo = {
      price: selectedDatePrice,
      date: selectedFlexDate,
      prevSearchInfo: {
        cheapestPrice: minimumListingPrice,
        travelDate,
      },
      validatingCarrier: flexDates[selectedIndex].minimumFare?.validatingCarrier,
      isSuperSearchBotItin: flexDates[selectedIndex].isSuperSearchBotItin,
      isSuperSearchItin: flexDates[selectedIndex].isSuperSearchItin,
      isExpressDeal: flexDates[selectedIndex].minimumFare?.isPrivateFare,
    }

    if (sliceInfo?.route_city && selectedFlexDate) {
      const key = `${sliceInfo.route_city}_${selectedFlexDate}`
      window.localStorage.setItem(key, JSON.stringify(selectedFlexDateInfo))
    }
  }

  logEvent('internal_link', {
    type: 'flex_dates',
    link_name: linkName,
    link_text: `${selectedDateFareType}_${linkText}`,
    page_name: 'listings',
    product_name: 'air',
  })
}

const formatPriceDifference = ({ selectedPrice, actualPrice, tripType }) => {
  const tripTypeTag = tripType.toLowerCase()
  if (!selectedPrice) {
    return `no-price-available_${tripTypeTag}`
  }

  const percentBuckets = [5, 10, 20]
  const priceDiff = actualPrice - selectedPrice
  const percentDiff = (priceDiff / selectedPrice) * 100

  const sign = priceDiff >= 0 ? '+' : '-'
  const absPercentDiff = Math.abs(Math.ceil(percentDiff))

  const matchingBucket = percentBuckets.find((bucket) => absPercentDiff <= bucket)
  const priceDiffTag = matchingBucket ? `${sign}<${matchingBucket}%` : `${sign}>20%`
  return `${priceDiffTag}_${tripTypeTag}`
}

const logFlexDatesPriceVerification = ({ selectedFlexDateData, minimumListingPrice, error, tripType }) => {
  const itemName = formatPriceDifference({
    selectedPrice: selectedFlexDateData?.price,
    actualPrice: minimumListingPrice,
    tripType,
  })

  logEvent('api_call', {
    type: 'flex_dates_price_verification',
    page_name: 'listings',
    product_name: 'air',
    success_flag: error ? 'n' : 'y',
    item_name: itemName,
  })
}

export { logFlexDatesDisplay, logFlexDatesClick, logFlexDatesPriceVerification }
